<template>
    <div class="tag-filter" :class="rootClasses">
        <div class="tag-filter--chip-collection">
            <div class="tag-filter--tag-wrapper tag-filter--chips">
                <div class="tag-filter--chip"
                        v-for="(item, idx) in previewItems"
                        :key="idx">
                    <a class="u-reset chip"
                            :class="{'chip__active': item.active}"
                            :href="item.path">
                        {{ item.label }}
                    </a>
                </div>
            </div>

            <transition name="trs-simple-fade">
                <div class="tag-filter--tag-wrapper tag-filter--chips"
                        v-if="showAllItems">
                    <div class="tag-filter--chip"
                            v-for="(item, idx) in hiddenItems"
                            :key="idx">
                        <a class="u-reset chip"
                                :class="{'chip__active': item.active}"
                                :href="item.path">
                            {{ item.label }}
                        </a>
                    </div>
                </div>
            </transition>
        </div>

        <div class="tag-filter--toggle-wrapper" v-if="items.length > maxTags">
            <button class="u-reset tag-filter--toggle" @click="toggleShowAll">
                <span v-if="showAllItems">{{ showLessLabel }}</span>
                <span v-else>{{ showAllLabel }}</span>
                <base-icon class="tag-filter--toggle-icon" symbol="chevron-down" size="small"/>
            </button>
        </div>
    </div>
</template>

<script>

    import bemMixin from 'framework/mixins/bem';

    export default {
        mixins: [bemMixin('tag-filter')],
        props: {
            /** @type {ILink[]} */
            items: {
                type: Array,
                required: true,
            },

            showLessLabel: {
                type: String,
                required: true,
            },
            showAllLabel: {
                type: String,
                required: true,
            },

            maxTags: {
                type: Number,
                required: true,
            },
        },

        data() {
            return {
                showAllItems: this.items.some(i => i.active),
            };
        },

        computed: {
            previewItems() {
                return this.items.slice(0, 3);
            },

            hiddenItems() {
                if (!this.showAllItems) {
                    return [];
                }

                return this.items.slice(3);
            },

            rootClasses() {
                return [
                    this.bemAdd(this.showAllItems ? 'show-all' : null),
                ];
            },
        },

        methods: {
            toggleShowAll() {
                this.showAllItems = !this.showAllItems;
            },
        },
    };
</script>
